export enum SourceTypeEnum {
  DERIBIT = 'DERIBIT',
  BINANCE = 'BINANCE',
  MEXC = 'MEXC',
  IMMERSIVE = 'IMMERSIVE',
}

export const normalizeExchangeToSource = (exchange: string): SourceTypeEnum => {
  const normalized = exchange.trim().toUpperCase();

  if (normalized === 'DERIBIT') return SourceTypeEnum.DERIBIT;
  if (normalized === 'BINANCE') return SourceTypeEnum.BINANCE;
  if (normalized === 'MEXC') return SourceTypeEnum.MEXC;
  if (normalized === 'IMMERSIVE') return SourceTypeEnum.IMMERSIVE;

  return SourceTypeEnum.DERIBIT;
};
